const EDUCATION_PREFIX = "scoutux:scan-education-dismissed";

export function isDiscoverEducationDismissed(userId: string) {
  return readFlag(educationStorageKey(userId));
}

export function dismissDiscoverEducation(userId: string) {
  writeFlag(educationStorageKey(userId));
}

function educationStorageKey(userId: string) {
  return `${EDUCATION_PREFIX}:${userId}`;
}

function readFlag(key: string) {
  if (typeof window === "undefined") {
    return false;
  }

  try {
    return window.localStorage.getItem(key) === "1";
  } catch {
    return false;
  }
}

function writeFlag(key: string) {
  if (typeof window === "undefined") {
    return;
  }

  try {
    window.localStorage.setItem(key, "1");
  } catch {
    // Ignore quota / private-mode failures; session state still covers this visit.
  }
}
